import type {StatsDashboadCordonneType} from "../types/stats-dashboad-cordonne.type";

export const StatistquesMockCordonnes: StatsDashboadCordonneType[] = [
   {x: 0, y: 100},
   {x: 1, y: 500},
   {x: 2, y: 3},
   // Ajoutez d'autres points de données ici
];
